import React from "react";
import { useHasPermission } from "../../auth/useClaims";
import { useBranchFilter } from "../../branchFilter/useBranchFilter";
import { useGetPettyCashLedgerQuery } from "../../pettycash/pettyCashApi";
import { dateRanges, money, sumBy } from "../dashboardHelpers";
import DashboardSectionCard from "../components/DashboardSectionCard";

const PettyCashTransactionsTodayCard = () => {
  const canView = useHasPermission("PettyCash.ViewLedger");
  const { selectedBranchId } = useBranchFilter();
  const dr = dateRanges();

  const { data, isFetching } = useGetPettyCashLedgerQuery(
    { branchId: selectedBranchId ?? undefined, dateFrom: dr.today, dateTo: dr.today, pageSize: 10 },
    { skip: !canView }
  );

  if (!canView) return null;

  const rows = data?.items || [];
  const cashOutToday = sumBy(rows, "creditAmount");

  return (
    <div className="col-12 col-xl-4">
      <DashboardSectionCard
        title="Petty Cash Transactions"
        headerRight="Today"
        isLoading={isFetching}
        isEmpty={rows.length === 0}
        emptyText="No transactions posted today."
      >
        <ul className="list-unstyled mb-2">
          {rows.map((row) => {
            const isIn = Number(row.debitAmount) > 0;
            return (
              <li key={row.ledgerId} className="d-flex justify-content-between align-items-start mb-2">
                <div>
                  <div className={`small fw-semibold ${isIn ? "text-success" : "text-danger"}`}>
                    {isIn ? "Cash In" : "Cash Out"}
                  </div>
                  <div className="text-muted small">{row.description || row.fundName}</div>
                </div>
                <span className={isIn ? "text-success fw-semibold" : "text-danger fw-semibold"}>
                  {money(isIn ? row.debitAmount : row.creditAmount)}
                </span>
              </li>
            );
          })}
        </ul>
        <hr className="my-2" />
        <div className="d-flex justify-content-between">
          <span className="fw-semibold">Total Cash Out</span>
          <span className="fw-bold text-danger">{money(cashOutToday)}</span>
        </div>
      </DashboardSectionCard>
    </div>
  );
};

export default PettyCashTransactionsTodayCard;
